import { __rest as e, __assign as a } from "../_virtual/_tslib.js";
import t, { useState as r, useMemo as n, useCallback as l, useEffect as o } from "react";
import { classPrefix as i, getYearsObject as c, getMonthsObject as d, getDaysObject as m } from "../utils/helpers.js";
import { OptionsRenderer as u } from "./OptionsRenderer.js";
import { SelectRenderer as s } from "./SelectRenderer.js";
var h = function (h) {
  var f = h.id,
    b = h.className,
    y = h.minDate,
    v = h.maxDate,
    p = h.selectedDate,
    g = h.onDateChange,
    D = h.disabled,
    N = void 0 !== D && D,
    E = h.hasError,
    L = void 0 !== E && E,
    R = h.monthRef,
    P = h.yearRef,
    j = h.dayRef,
    C = h.labels,
    Y = void 0 === C ? {} : C,
    x = h.order,
    O = void 0 === x ? "month/day/year" : x,
    S = h.reverseYears,
    H = h.hideLabels,
    M = e(h, ["id", "className", "minDate", "maxDate", "selectedDate", "onDateChange", "disabled", "hasError", "monthRef", "yearRef", "dayRef", "labels", "order", "reverseYears", "hideLabels"]),
    _ = r(-1),
    k = _[0],
    F = _[1],
    w = r(-1),
    q = w[0],
    z = w[1],
    A = r(-1),
    B = A[0],
    G = A[1],
    I = n(function () {
      return O ? O.split("/") : ["month", "day", "year"];
    }, [O]),
    J = n(function () {
      return ["".concat(i, "_react-select-datepicker"), b].join(" ");
    }, [b]),
    K = n(function () {
      return t.createElement(u, {
        options: c(y, v, S)
      });
    }, [v, S, y]),
    Q = n(function () {
      return t.createElement(u, {
        options: d(y, v, k, Y.months)
      });
    }, [v, Y.months, y, k]),
    T = n(function () {
      return t.createElement(u, {
        options: m(y, v, q, k)
      });
    }, [v, q, y, k]),
    U = l(function (e) {
      F(Number(e.target.value)), d(y, v, Number(e.target.value)).some(function (e) {
        return e.value === q;
      }) || z(-1), m(y, v, q, Number(e.target.value)).some(function (e) {
        return e.value === B;
      }) || G(-1);
    }, [B, q, y, v]),
    V = l(function (e) {
      z(Number(e.target.value)), m(y, v, Number(e.target.value), k).some(function (e) {
        return e.value === B;
      }) || G(-1);
    }, [B, k, y, v]),
    W = l(function (e) {
      G(Number(e.target.value));
    }, []),
    X = n(function () {
      return {
        day: t.createElement(s, {
          id: "day",
          labels: {
            hide: H,
            main: Y.dayLabel || "Day",
            placeholder: Y.dayPlaceholder || "Select Day"
          },
          value: B,
          disabled: N,
          onChangeHandler: W,
          selectOptions: T,
          ref: j
        }),
        month: t.createElement(s, {
          id: "month",
          labels: {
            hide: H,
            main: Y.monthLabel || "Month",
            placeholder: Y.monthPlaceholder || "Select Month"
          },
          value: q,
          disabled: N,
          onChangeHandler: V,
          selectOptions: Q,
          ref: R
        }),
        year: t.createElement(s, {
          id: "year",
          labels: {
            hide: H,
            main: Y.yearLabel || "Year",
            placeholder: Y.yearPlaceholder || "Select Year"
          },
          value: k,
          disabled: N,
          onChangeHandler: U,
          selectOptions: K,
          ref: P
        })
      };
    }, [B, T, j, N, W, V, U, H, Y.dayLabel, Y.dayPlaceholder, Y.monthLabel, Y.monthPlaceholder, Y.yearLabel, Y.yearPlaceholder, q, Q, R, k, K, P]);
  return o(function () {
    null != p && (G(Number(p.getDate())), z(Number(p.getMonth() + 1)), F(Number(p.getFullYear())));
  }, [p]), o(function () {
    g(-1 !== k && -1 !== q && -1 !== B ? new Date("".concat(q, "/").concat(B, "/").concat(k)) : null);
  }, [B, q, k]), t.createElement("div", a({}, M, {
    style: {
      display: "flex"
    },
    id: f,
    className: J
  }, L ? {
    "aria-invalid": !0
  } : null), I.map(function (e, a) {
    return t.createElement(t.Fragment, {
      key: "".concat(e, "-").concat(a)
    }, X[e]);
  }));
};
export { h as SelectDatepicker };